import React, { useContext } from 'react'
import SnackbarItem from './component/snackbar-item'
import { SnackbarListWrapper } from './styled-components'
import { SnackbarContext } from './component/snackbar-context'
import { isEmpty } from 'lodash'

const SnackbarComponent = ({ ...props }) => {
  const { removeSnackbar, snackbarsList } = useContext(SnackbarContext)

  if (isEmpty(snackbarsList)) {
    return null
  }

  return (
    <SnackbarListWrapper {...props}>
      {snackbarsList.map((snack, key) => (
        <SnackbarItem
          key={snack.id ?? `snackbar-${key}`}
          id={snack.id ?? key}
          message={snack.message}
          snackbarType={snack.snackbarType}
          buttonAction={snack.buttonAction}
          persistOpen={snack.persistOpen}
          timeToHide={snack.timeToHide}
          hideCloseButton={snack.hideCloseButton}
          onClose={() => removeSnackbar(snack.id)}
          {...snack}
        />
      ))}
    </SnackbarListWrapper>
  )
}

export default SnackbarComponent
